export default __webpack_public_path__ + "images/0xd533a949740bb3306d119cc777fa900ba034cd52.png";